export const getRelators2 = () =>[
    {
        src: '/assets/relator/portrait.svg',
        alt: '',
        name: 'ESTER ALBA PAGÁN',
        description: `Vicerrectora de Cultura i
         Societat Universitat de
         Valencia, España.`,
        flag:'/assets/banderas/espana.svg',
    },
    {
        src: '/assets/relator/portrait.svg',
        alt: '',
        name: 'JOSÉ VICENTE',
        description: `Académico Universidad
         de Valencia, 
         España.`,
        flag:'/assets/banderas/espana.svg',
    },
    /*
    {
        src: '/assets/relator/portrait.svg',
        alt: '',
        name: 'PETER SHARP',
        description: `Técnica de Organización y
         Modernización Municipal
         Ayuntamiento de Gandia
         España`,
        flag:'/assets/banderas/espana.svg',
    },
     */
    {
        src: '/assets/relator/gloria_sanmiguel.jpg',
        alt: '',
        name: 'GLORIA SANMIGUEL',
        description: `Técnica en Transparencia
         Ayuntamiento de Gandia
         España.`,
        flag:'/assets/banderas/espana.svg',
    },
    {
        src: '/assets/relator/hans_guitierrez.png',
        alt: '',
        name: 'HANS GUTIÉRREZ',
        description: `Psicólogo, presidente
         Asociación Peruana de
         facilitadores, Director DH
         facilitadores, Perú.`,
        flag:'/assets/banderas/peru.svg',
    },
    {
        src: '/assets/relator/portrait.svg',
        alt: '',
        name: 'MARÍA CECILIA JIMENEZ',
        description: `Unidad de Control,
         Municipalidad de
         Peñalolén
         Chile.`,
        flag:'/assets/banderas/chile.svg',
    },
    {
        src: '/assets/relator/foto3.jpg',
        alt: '',
        name: 'JOSÉ MORA',
        description: `Analista de Datos Fundación
         Observatorio Fiscal 
         Chile.`,
        flag:'/assets/banderas/chile.svg',
    }
]
